/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import {
  BaseAlertCardTaskFragmentDoc,
  BaseAlertCardVehicleFragmentDoc,
} from '../../../../alert-cards-common/src/lib/BaseAlertCard/BaseAlertCard.hook'
import { VehicleIconLinkVehicleFragmentDoc } from '../../../../alert-cards-common/src/lib/VehicleIconLink/vehicleIconLink.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { DefaultActionsOpenAlertFragmentDoc } from '../components/DefaultActionsOpenAlert/defaultActionsOpenAlert.hook'
import { MarkAsResolvedButtonAlertFragmentDoc } from '../components/MarkAsResolvedButton/markAsResolvedButton.hook'
import {
  MetaPhoneDriverEmployeeFragmentDoc,
  MetaPhoneDriverVehicleFragmentDoc,
} from '../components/MetaPhoneDriver/metaPhoneDriver.hook'
import { DefaultAlertCardDataAlertFragmentDoc } from '../hook/useDefaultAlertCardData/useDefaultAlertCardData.hook'
export type VehicleHasLowSocAlertCardAlertFragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    highVoltageBatteryLevel: number | null
    cruisingRange: number | null
    totalPassengersInVehicle: number | null
    id: string
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const VehicleHasLowSocAlertCardAlertFragmentDoc = gql`
    fragment VehicleHasLowSocAlertCardAlert on VehicleSurveillanceNotification {
  id
  status
  employee {
    ...MetaPhoneDriverEmployee
  }
  vehicle {
    highVoltageBatteryLevel
    cruisingRange
    totalPassengersInVehicle
    ...MetaPhoneDriverVehicle
    ...VehicleIconLinkVehicle
    ...BaseAlertCardVehicle
  }
  ...DefaultActionsOpenAlert
  ...MarkAsResolvedButtonAlert
  ...DefaultAlertCardDataAlert
  ...BaseAlertCardTask
}
    ${MetaPhoneDriverEmployeeFragmentDoc}
${MetaPhoneDriverVehicleFragmentDoc}
${VehicleIconLinkVehicleFragmentDoc}
${BaseAlertCardVehicleFragmentDoc}
${DefaultActionsOpenAlertFragmentDoc}
${MarkAsResolvedButtonAlertFragmentDoc}
${DefaultAlertCardDataAlertFragmentDoc}
${BaseAlertCardTaskFragmentDoc}`
